var exports = {
  "FB": "PageHeader_TitleArea__U_Vhwa",
  "Hq": "actionsContainer__AF6ivK",
  "o4": "subtitleText__mfUnU4",
};

module.exports = exports;
